import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import NewWindow from "react-new-window";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import Download from "@mui/icons-material/Download";
import { Button, IconButton } from "@mui/material";
import { getRecordingFiles } from "../Store/Actions/CallAction";

const ActionColumn = ({
  params,
  setSelectedChatListID,
  setSelectedTranscription,
  setSelectedWAID,
  setIsModalHistoryShown,
  setisModalTranscriptionShown,
}) => {
  const [isRecordingLoading, setIsRecordingLoading] = useState(false);
  const [isRecordingPlaying, setIsRecordingPlaying] = useState(false);
  const [isSeekVoiceAllowed, setIsSeekVoiceAllowed] = useState(null);
  const [selectedRecording, setSelectedRecording] = useState(null);
  const { agentPermission } = useSelector((state) => state.auth);
  const recordingRef = useRef(null);

  // Get seek voice permission
  useEffect(() => {
    const seekVoicePermission = agentPermission.find(
      (permission) => permission.PermissionCode === "User.SeekVoice"
    );

    if (seekVoicePermission && seekVoicePermission.PermissionAccess === "A") {
      setIsSeekVoiceAllowed(true);
    } else {
      setIsSeekVoiceAllowed(false);
    }
  }, [agentPermission]);

  // Event listener for audio `ended` event
  useEffect(() => {
    recordingRef.current &&
      recordingRef.current.addEventListener("ended", () =>
        setIsRecordingPlaying(false)
      );

    return () => {
      recordingRef.current &&
        recordingRef.current.removeEventListener("ended", () =>
          setIsRecordingPlaying(false)
        );
    };
  }, [recordingRef.current]);

  return (
    <>
      <audio ref={recordingRef}>
        <source src={`data:audio/wav;base64,${selectedRecording?.filebytes}`} />
      </audio>

      <IconButton
        onClick={() => {
          if (
            params.row.InteractionType === "WHATSAPP" ||
            params.row.InteractionType === "WABA"
          ) {
            console.log("chat selected");
            setSelectedChatListID(params.row.FK_ChatListID);

            params.row.InteractionType === "WABA" &&
              setSelectedWAID(params.row.Address);

            setIsModalHistoryShown(true);
          } else if (
            (params.row.InteractionType === "MANUALCALL" ||
              params.row.InteractionType === "AUTOMATICCALL") &&
            !selectedRecording
          ) {
            setIsRecordingLoading(true);

            getRecordingFiles(params.row.RecMessageID)
              .then((response) => {
                if (response.status) {
                  setSelectedRecording(response.data);

                  recordingRef.current = new Audio(
                    `data:audio/wav;base64,${response.data.filebytes}`
                  );

                  setIsRecordingLoading(false);
                } else {
                  console.log("error", response.error);
                  toast.error(response.error);
                  setIsRecordingLoading(false);
                }
              })
              .catch((err) => {
                console.log("err", err);
                toast.error(err);
                setIsRecordingLoading(false);
              });
          } else if (isRecordingLoading) {
            return;
          }
        }}
      >
        <Icon
          color="#7e7e7e"
          height="26"
          icon={
            params.row.InteractionType === "WHATSAPP" ||
            params.row.InteractionType === "WABA"
              ? "ic:baseline-remove-red-eye"
              : isRecordingLoading
              ? "eos-icons:loading"
              : // : selectedRecording && !recordingRef.current.paused
                // ? "ion:pause"
                "ion:play"
          }
          width="26"
        />
      </IconButton>

      {(params.row.InteractionType === "MANUALCALL" ||
        params.row.InteractionType === "AUTOMATICCALL") && (
        <IconButton
          onClick={() => {
            setisModalTranscriptionShown(true);

            setSelectedTranscription(
              params.row.RecMessageID?.replace("rds", "internal")
            );
          }}
        >
          <Icon
            color="#7e7e7e"
            height="26"
            icon="material-symbols:speech-to-text"
            width="26"
          />
        </IconButton>
      )}

      {selectedRecording && (
        <NewWindow
          features={{
            height: 100,
            width: 400,
          }}
          onUnload={() => setSelectedRecording(null)}
        >
          <div
            className={`controls new-window ${
              !isSeekVoiceAllowed ? "simple" : ""
            }`}
          >
            {isSeekVoiceAllowed ? (
              // Audio with controls if seek voice is allowed
              <audio
                controls
                controlsList="nodownload"
                src={`data:audio/wav;base64,${selectedRecording?.filebytes}`}
              />
            ) : (
              // Play/pause button if seek voice is not allowed
              <Button
                className="download-button"
                variant="contained"
                onClick={() => {
                  if (isRecordingPlaying) {
                    recordingRef.current.pause();
                    setIsRecordingPlaying(false);
                  } else {
                    recordingRef.current.play();
                    setIsRecordingPlaying(true);
                  }
                }}
              >
                {isRecordingPlaying ? (
                  <Icon height="24" icon="ic:round-pause" />
                ) : (
                  <Icon height="24" icon="ph:play-fill" />
                )}
              </Button>
            )}

            <a
              download={selectedRecording?.filename}
              href={`data:audio/wav;base64,${selectedRecording?.filebytes}`}
            >
              <Button variant="contained" className="download-button">
                <Download />
              </Button>
            </a>
          </div>
        </NewWindow>
      )}
    </>
  );
};

export default ActionColumn;
